import { Box, List, Text, Flex } from "@chakra-ui/react";
import useNumberFormatter from "../../../../hooks/useNumberFormatter";
import { ElementType } from "react";

type Props = {
  lable: string;
  value: number | string | undefined;
  share: number | string | undefined;
  icon?: ElementType;
  color?: string;
};

const ListItemStatCard = ({
  lable,
  value,
  share,
  icon: IconComponent,
  color = "#6887D8",
}: Props): JSX.Element => {
  const formatNumber = useNumberFormatter();

  const formattedValue =
    typeof value === "number" ? formatNumber(value) : value;

  const numericShare =
    typeof share === "number" ? share : parseFloat(share as string) || 0;

  return (
    <List.Item
      display={"flex"}
      flexDirection={"column"}
      py={2}
      borderBottom={"1px solid #ebecef80"}
    >
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        <Flex alignItems="center" gap={2}>
          {IconComponent && <IconComponent size={18} color={color} />}
          <Text color={"#54596C"} fontSize="0.9rem" fontWeight="600">
            {lable}
          </Text>
        </Flex>

        <Flex gap={3} alignItems="center">
          <Text fontWeight="600" color="#1A202C">
            {formattedValue || 0}
          </Text>
          <Box
            bg={`${color}20`} // 20% opacity of the given hex color
            borderRadius="md"
            px={2}
            py={0.5}
            display="flex"
            justifyContent="center"
            minWidth="3rem"
          >
            <Text color={color} fontSize="0.8rem" fontWeight="700">
              {`${numericShare}%`}
            </Text>
          </Box>
        </Flex>
      </Flex>

      {/* Progress Bar */}
      <Box w="100%" h="4px" bg="#F1F3F5" borderRadius="full" overflow="hidden">
        <Box
          h="100%"
          bg={color}
          w={`${Math.min(Math.max(numericShare, 0), 100)}%`}
          borderRadius="full"
        />
      </Box>
    </List.Item>
  );
};

export default ListItemStatCard;
